import React from 'react';
        import { WifiOff } from 'lucide-react';
        import { getSupabaseStatus } from '../../lib/supabase';

        const ConnectionStatus = () => {
          const status = getSupabaseStatus();
          
          if (status?.configured) {
            return null; // Don't show anything when properly connected
          }

          return (
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <WifiOff className="h-5 w-5 text-yellow-400" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-yellow-800">
                    Site Running in Offline Mode
                  </h3>
                  <div className="mt-2 text-sm text-yellow-700">
                    <p>
                      The site is currently running with limited functionality. 
                      Database features like user accounts, alerts, and data storage are unavailable.
                    </p>
                    <div className="mt-2">
                      <p className="font-medium">To restore full functionality:</p>
                      <ol className="mt-1 list-decimal list-inside space-y-1">
                        <li>Configure your Supabase anonymous key in the environment settings</li>
                        <li>The key should start with 'eyJ' and be obtained from your Supabase project</li>
                        <li>Contact support if you need assistance with configuration</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        };

        export default ConnectionStatus;